module.exports = function getResource(label, vars = []) {
    let resources = {
        title: 'Récemment consulté'
    };

    return resources[label];
};
